import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class DeleteExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.DeleteExpression;
    }
    visitNode(sb, expr, _options) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=DeleteExpressionCompiler.js.map
